import { render } from "./RecursoCreate.vue?vue&type=template&id=bd959690&scoped=true"
import script from "./RecursoCreate.vue?vue&type=script&lang=js"
export * from "./RecursoCreate.vue?vue&type=script&lang=js"

import "./RecursoCreate.vue?vue&type=style&index=0&id=bd959690&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd959690"]])

export default __exports__